import type { 
  GetDomainsManagementServiceRotationGroupsCountData,
  GetDomainsManagementServiceRotationGroupsCountResponse,

  GetDomainsManagementServiceRotationGroupsData,
  GetDomainsManagementServiceRotationGroupsResponse,

  PostDomainsManagementServiceRotationGroupsData,
  PostDomainsManagementServiceRotationGroupsResponse,

  GetDomainsManagementServiceRotationGroupsByIdData,
  GetDomainsManagementServiceRotationGroupsByIdResponse,


  PutDomainsManagementServiceRotationGroupsByIdData,
  PutDomainsManagementServiceRotationGroupsByIdResponse,
  
  DeleteDomainsManagementServiceRotationGroupsByIdData,
  DeleteDomainsManagementServiceRotationGroupsByIdResponse,
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";



export function getRotationGroupsApiModule(affiliatesApi: AxiosInstance) {
  return {
    /**
     * Get rotation groups count
     *
     * @param {Object} params
     * @param {String} params.search
     *
     * @return {Promise<Object>} api response
     */
    getRotationGroupsCount(params: GetDomainsManagementServiceRotationGroupsCountData[]) {
      return affiliatesApi.get<GetDomainsManagementServiceRotationGroupsCountResponse>(
        '/domains-management/service-rotation-groups/count',
        { params }
      );
    },

    /**
     * Get rotation groups
     *
     * @param {Object} params
     * @param {String} params.sort_column
     * @param {String} params.sort_dir
     * @param {String} params.search
     * @param {Number} params.limit
     * @param {Number} params.offset
     *
     * @return {Promise<Object>} api response
     */
    getRotationGroups(params: GetDomainsManagementServiceRotationGroupsData['query']) {
      return affiliatesApi.get<GetDomainsManagementServiceRotationGroupsResponse>(
        '/domains-management/service-rotation-groups',
        { params }
      );
    },

    /**
     * Create rotation group
     *
     * @param {Object} data
     * @param {String} data.name
     * @param {String} data.description
     * @param {String} data.auto_replace_banned_domains
     *
     * @return {Promise<Object>} api response
     */
    createRotationGroup(data: PostDomainsManagementServiceRotationGroupsData['body']) {
      return affiliatesApi.post<PostDomainsManagementServiceRotationGroupsResponse>(
        '/domains-management/service-rotation-groups',
        data
      );
    },

    /**
     * Get rotation group by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    getRotationGroupById(id: string) {
      return affiliatesApi.get<GetDomainsManagementServiceRotationGroupsByIdResponse>(
        `/domains-management/service-rotation-groups/${id}`
      );
    },

    /**
     * Update rotation group
     *
     * @param {String} id
     * @param {Object} data
     * @param {String} data.name
     * @param {String} data.description
     * @param {String} data.auto_replace_banned_domains
     *
     * @return {Promise<Object>} api response
     */
    updateRotationGroup(id: string, data: PutDomainsManagementServiceRotationGroupsByIdData['body']) {
      return affiliatesApi.put<PutDomainsManagementServiceRotationGroupsByIdResponse>(
        `/domains-management/service-rotation-groups/${id}`,
        data
      );
    },

    /**
     * Delete rotation group by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    deleteRotationGroup(id: string) {
      return affiliatesApi.delete<DeleteDomainsManagementServiceRotationGroupsByIdResponse>(
        `/domains-management/service-rotation-groups/${id}`
      );
    },
  }
}
